import { jsxs as _jsxs, jsx as _jsx } from "preact/jsx-runtime";
import { useSyncExternalStore } from 'preact/compat';
import { useEffect, useMemo, useRef } from 'preact/hooks';
import { createGooglePickerController, createGooglePickerStoreAdapter, } from '../../companion-client/index.js';
import AuthView from '../ProviderView/AuthView.js';
import { GoogleDriveIcon, GooglePhotosIcon } from './icons.js';
export function useGooglePicker({ uppy, requestClientId, companionUrl, pickerType, clientId, apiKey, appId, storage, store, }) {
    const { subscribe, getSnapshot } = store;
    const { reset, init, ...rest } = useMemo(() => createGooglePickerController({
        uppy,
        requestClientId,
        companionUrl,
        pickerType,
        clientId,
        apiKey,
        appId,
        storage,
        store,
    }), [
        uppy,
        requestClientId,
        clientId,
        companionUrl,
        pickerType,
        apiKey,
        appId,
        storage,
        store,
    ]);
    useEffect(() => {
        init();
        return () => {
            reset();
        };
    }, [reset, init]);
    return { ...useSyncExternalStore(subscribe, getSnapshot), ...rest };
}
export default function GooglePickerView({ getPluginState, setPluginState, uppy, i18n, clientId, pickerType, apiKey, appId, storage, requestClientId, companionUrl, }) {
    const store = useMemo(() => createGooglePickerStoreAdapter({ uppy, getPluginState, setPluginState }), [uppy, getPluginState, setPluginState]);
    const googlePicker = useGooglePicker({
        uppy,
        requestClientId,
        companionUrl,
        pickerType,
        clientId,
        apiKey,
        appId,
        storage,
        store,
    });
    const shownPickerRef = useRef(false);
    useEffect(() => {
        // when mounting, once we have a token, be nice to the user and automatically show the picker
        // googlePicker.accessToken === undefined means not yet loaded from storage, so wait for that first
        if (googlePicker.accessToken === undefined || shownPickerRef.current) {
            return;
        }
        shownPickerRef.current = true;
        googlePicker.show();
    }, [googlePicker.show, googlePicker.accessToken]);
    if (googlePicker.loading) {
        return _jsxs("div", { children: [i18n('pleaseWait'), "..."] });
    }
    if (googlePicker.accessToken == null) {
        return (_jsx(AuthView, { pluginName: pickerType === 'drive'
                ? i18n('pluginNameGoogleDrivePicker')
                : i18n('pluginNameGooglePhotosPicker'), pluginIcon: pickerType === 'drive' ? GoogleDriveIcon : GooglePhotosIcon, handleAuth: googlePicker.show, i18n: i18n, loading: googlePicker.loading }));
    }
    return (_jsxs("div", { style: { textAlign: 'center' }, children: [_jsx("button", { type: "button", className: "uppy-u-reset uppy-c-btn uppy-c-btn-primary", style: { display: 'block', marginBottom: '1em' }, disabled: googlePicker.loading, onClick: googlePicker.show, children: pickerType === 'drive' ? i18n('pickFiles') : i18n('pickPhotos') }), _jsx("button", { type: "button", className: "uppy-u-reset uppy-c-btn", disabled: googlePicker.loading, onClick: googlePicker.logout, children: i18n('logOut') })] }));
}
